import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AiOutlineBars } from "react-icons/ai";
import logo from "../assets/images/logo.png";

const formatDate = (value) => {
	const date = new Date(value);
	if (isNaN(date.getTime())) return "";
	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
};

// Shows the event photo, or the organisation logo when there is no photo
// or the photo cannot be loaded.
const EventImage = ({ src, title }) => {
	const [failed, setFailed] = useState(false);
	const hasPhoto = Boolean(src) && !failed;
	return (
		<img
			className={hasPhoto ? "" : "no-image"}
			src={hasPhoto ? src : logo}
			alt={hasPhoto ? title : "Champawati Saving and Credit Co-operative"}
			onError={() => setFailed(true)}
		/>
	);
};

const EventsPage = () => {
	const [eventsData, setEventsData] = useState([]);

	useEffect(() => {
		fetch("/api/events/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) {
					setEventsData(
						[...data].sort((a, b) => new Date(b.date) - new Date(a.date))
					);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	return (
		<section className='eventspage-wrapper'>
			<h2>News/Events</h2>
			<div className='eventspage'>
				<ul>
					{eventsData.map((event) => (
						<li key={event.id}>
							<EventImage src={event.image} title={event.title} />
							<div className='content'>
								<h3 className='title'>{event.title}</h3>
								<p className='date'>
									<span>Published Date: </span>
									{formatDate(event.date)}
								</p>

								{event.description ? (
									<p>
										{event.description.length > 100
											? `${event.description.substring(0, 100)}...`
											: event.description}
									</p>
								) : null}

								<button className='btn btn-success'>
									{event.outside_url ? (
										<a
											href={event.outside_url}
											target='_blank'
											rel='noopener noreferrer'
										>
											<AiOutlineBars className='icon' />
											READ MORE
										</a>
									) : (
										<Link to={`/singleevent/${event.id}`}>
											<AiOutlineBars className='icon' />
											KNOW MORE
										</Link>
									)}
								</button>
							</div>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default EventsPage;
